<template>
  <div class="lostpassword-page">
    <div class="lostpassword-container">
      <div class="profile-picture"></div>
      <div class="profile">
        <div>Vul je e-mail in en we versturen je de instructies</div>
        <b>Wachtwoord vergeten?</b>
      </div>
      <button-component @click.native="onLostpasswordClick"
        >Wachtwoord aanvragen</button-component
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { RouteName } from '../utils/enums';
import ButtonComponent from '../components/button.component';

export default {
  name: 'login-page',
  components: {
    ButtonComponent
  },
  data: function() {
    return {
      email: 'test',
      password: 'test'
    };
  },
  methods: {
    onLostpasswordClick: function() {
      alert('lost-password');
    }
  }
};
</script>

<style scoped lang="scss">
.lostpassword-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url('../assets/backgrounds/background-small.svg');
  background-size: 100% auto;
  background-position: bottom;
}

.lostpassword-container {
  width: 335px;
}

.profile {
  font-size: 14px;
  text-align: center;

  div {
    margin-bottom: 4px;
  }
}

.profile-picture {
  width: 84px;
  height: 84px;
  background-color: $white;
  border-radius: 50%;
  margin: 0 auto 18px;
  box-shadow: 0 2px 8px 0 rgba($black, 0.1);
  background-image: url('../assets/icons/profile-blue-large.svg');
  background-position-y: 10px;
}

.button-component {
  margin-top: 90px;
}

.lost-password {
  position: absolute;
  bottom: 20px;
  color: $primary;
  cursor: pointer;
}
</style>
